import { Row, Space } from '@stenajs-webui/core';
import { InputSpinner } from '@stenajs-webui/elements';
import { type FC, lazy, type ReactNode, Suspense } from 'react';

const VehicleTypeIcon = lazy(() => import('./VehicleTypeIcon'));

export interface VehicleTypeRowWithIconProps {
  children?: ReactNode;
  vehicleTypeCode: string;
}

export const VehicleTypeRowWithIcon: FC<VehicleTypeRowWithIconProps> = ({
  children,
  vehicleTypeCode,
}) => {
  return (
    <Row alignItems="center" justifyContent="space-between">
      <Suspense fallback={<InputSpinner />}>
        <VehicleTypeIcon type={vehicleTypeCode} />
      </Suspense>
      <Space />
      <Row className={'t_vehicle_type_option'} flexGrow={1}>
        {children}
      </Row>
    </Row>
  );
};
